export enum GalleryStatus {
    DRAFT = 'DRAFT',
    PENDING_APPROVAL = 'PENDING_APPROVAL',
    APPROVED = 'APPROVED',
    REJECTED = 'REJECTED',
}

export function getStatusColor(status: GalleryStatus): string {
    switch (status) {
        case GalleryStatus.DRAFT: return 'gray';
        case GalleryStatus.PENDING_APPROVAL: return 'orange';
        case GalleryStatus.APPROVED: return 'green';
        case GalleryStatus.REJECTED: return 'red';
        default: return 'black';
    }
}
